export class AppUrl {
  host: string = "https://admapp.netsulinternet.com.br"; // producao - https://admapp.netsulinternet.com.br
  host_assine: string = "http://172.20.0.65:6063";
  host_minha_loga: string = "http://localhost:4200/#/";
  host_ms_fatura: string = "https://sgt.loga.net.br/z25f6ab772";
}



// WEBPACK FOOTER //
// /var/www/minha-netsul/src/app/app-url.ts